(function () {
  'use strict';

  var root = document.querySelector('[data-cc-designer-notes]');
  if (!root) return;

  var textarea = root.querySelector('[data-cc-notes-input]');
  var counter = root.querySelector('[data-cc-counter]');
  var label = root.dataset.label || 'Notes';
  var property = root.dataset.property || label;
  var maxChars = parseInt(root.dataset.maxChars, 10) || 500;
  var required = root.hasAttribute('data-required');

  function dispatch() {
    // Whitespace-only notes never satisfy a required gate
    var filled = textarea.value.trim() !== '' ? 1 : 0;
    // Blank notes post NO key. See cc-join.js for why this is done by form
    // ownership and never by touching the name attribute.
    window.ccSubmitWhenFilled(textarea);
    document.dispatchEvent(new CustomEvent('cc:notes-changed', {
      detail: {
        property: property,
        label: label,
        filled: filled,
        min: 1,
        required: required
      }
    }));
  }

  // Auto-grow: the field opens at one row and grows to fit whatever is typed,
  // including soft-wrapped lines, so there is never an inner scrollbar and no
  // dead space before the customer types. Height is reset to 'auto' first so
  // the box can SHRINK again when text is deleted.
  //
  // scrollHeight covers content + padding but not borders, while the CSS uses
  // box-sizing:border-box, so the borders have to be added back or the field
  // ends up a couple of pixels short and scrolls by one line.
  function autoGrow() {
    textarea.style.height = 'auto';
    var borders = textarea.offsetHeight - textarea.clientHeight;
    textarea.style.height = (textarea.scrollHeight + borders) + 'px';
  }

  function updateCounter() {
    var len = textarea.value.length;
    if (counter) {
      counter.hidden = len === 0;
      counter.textContent = len + '/' + maxChars + ' characters';
      counter.classList.toggle('is-warning', len > maxChars * 0.8 && len < maxChars);
      counter.classList.toggle('is-full', len >= maxChars);
    }
  }

  // No character filtering — customers write real instructions with
  // punctuation, numbers, line breaks. Newlines are PRESERVED in the cart
  // property (designers benefit from formatting; see Alex backlog re: CSV).
  textarea.addEventListener('input', function () {
    autoGrow();
    updateCounter();
    dispatch();
  });

  // Re-measure when the line length changes: a narrower box rewraps the text
  // and needs more rows. Also covers the picker being revealed after load,
  // when a hidden element would have measured 0.
  window.addEventListener('resize', autoGrow);
  textarea.addEventListener('focus', autoGrow);

  autoGrow();
  updateCounter();
  dispatch();
})();
